<template>
    <div class="booking-component text-none pa-4 pa-md-2">
        <div class="main-header mb-6 mt-6 w-100 d-flex flex-row justify-space-between align-center">
          <div class="text-left">
            Lista rezerwacji
          </div>
          <v-btn flat variant="plain" color="primary"
            :class="['']" 
            :size="$vuetify.display.mobile ? 'x-small' : 'x-default'" @click="showFilters = !showFilters">
              <span v-if="showFilters">Ukryj filtry</span>
              <span v-else>Pokaż filtry</span>
          </v-btn>
        </div>

        <div class="filter-wrapper" v-if="showFilters">
          <div class="filter-header text-left pa-md-6 pb-md-0 pa-0 pb-6 d-flex flex-row align-center">
            <img :src="box_icon" class="mr-2" /> Rezerwacje
          </div>
          <div class="search-bar text-left pa-md-6 pa-0 d-flex flex-md-row flex-column">
            <div class="search-bar-element mr-4 d-flex flex-column align-start w-100">
              <div class="search-bar-label mb-2 mt-md-0 mt-0">
                Imię / Nazwisko / PESEL Pacjenta
              </div>
              <input 
                :class="[$vuetify.display.mobile ? 'w-100' : 'w-100', 'search-bar-input']" 
                placeholder="Wpisz, aby znaleźć rezerwację" v-model="search_data.query" @change="setNewFilters"/>
            </div>
            <div class="search-bar-element mr-6 d-flex flex-column align-start w-100">
              <div class="search-bar-label mb-2 mt-md-0 mt-4">
                Nr rezerwacji / ID Dawcy
              </div>
              <input :class="[$vuetify.display.mobile ? 'w-100' : 'w-50', 'search-bar-input']" v-model="search_data.id"/>
            </div>
            <v-spacer></v-spacer>
          </div>
          <div class="search-bar text-left pa-md-6 pa-0 d-flex flex-md-row flex-column align-start align-md-center justify-space-between">
            <div class="search-bar-element mr-4 d-flex flex-column align-start w-100">
              <div class="search-bar-label mb-2 mt-md-0 mt-4">
                Miejsce leczenia
              </div>
              <div class="search-bar-select-wrapper">
                <select class="search-bar-select" v-model="search_data.selected_location" >
                  <option value="" selected>Wszystkie lokalizacje</option>
                  <option v-for="(location, index) in locations" :value="location.name" :key="index" >{{ location.name }}
                  </option>
                </select>
                <v-icon class="select-icon" v-if="location_open">mdi-chevron-up</v-icon>
                <v-icon class="select-icon" v-else>mdi-chevron-down</v-icon>
              </div>
            </div>
            <div class="search-bar-element mr-4 d-flex flex-column align-start w-100">
              <div class="search-bar-label mb-2 mt-md-0 mt-4">
                Status
              </div>
              <div class="search-bar-select-wrapper">
                <select class="search-bar-select" v-model="search_data.selected_status">
                  <option value="" selected>Wszystkie statusy</option>
                  <option v-for="(status, index) in statuses" :value="status.id" :key="index">{{this.$t(`status.${status.code}`)}}
                  </option>
                </select>
                <v-icon class="select-icon" v-if="status_open">mdi-chevron-up</v-icon>
                <v-icon class="select-icon" v-else>mdi-chevron-down</v-icon>
              </div>
            </div>
            <div class="search-bar-element mr-4 d-flex flex-column align-start w-100">
              <div class="search-bar-label mb-2 mt-md-0 mt-4">
                Data rezerwacji
              </div>
              <input type="date" class="search-bar-input" v-model="search_data.selected_date" />
            </div>
            <div class="search-bar-element mr-4 d-flex flex-column align-start w-100">
              <div class="search-bar-label mb-4 mt-md-0 mt-4">
                &nbsp;
              </div>
              <label class="container input-label text-left pr-2 mb-2">
                <input type="checkbox" v-model="search_data.is_mz" @change="setNewFilters">
                <span class="checkmark"></span> Program MZ
              </label>
            </div>
            <!-- <v-spacer></v-spacer> -->
          </div>

          <v-divider class="my-md-3 my-6 mx-md-6"></v-divider>

          <div class="filter-header text-left pa-md-6 pb-md-0 pa-0 pb-6 d-flex flex-row align-center">
            <img :src="truck_icon" class="mr-2" /> Transport
            <v-btn
              rounded
              variant="outlined"
              color="primary"
              height="40"
              class="text-uppercase ml-9"
              @click="goToOrderTransport"
            >
              Zleć transport
            </v-btn>
          </div>

          <div class="search-bar text-left pa-md-6 pa-0 d-flex flex-md-row flex-column align-start align-md-center justify-space-between mr-0 mr-md-16">
            <div :class="[$vuetify.display.mobile ? 'w-100' : 'w-25 mr-4','search-bar-element d-flex flex-column align-start']">
              <div class="search-bar-label mb-2 mt-md-0 mt-4">
                Status
              </div>
              <div class="search-bar-select-wrapper">
                <select class="search-bar-select" v-model="search_data.selected_transport_status">
                  <option value="" selected>Wszystkie statusy</option>
                  <option v-for="(status, index) in transport_statuses" :value="status.code" :key="index">{{this.$t(`status.${status.code}_transport`)}}
                  </option>
                </select>
                <v-icon class="select-icon" v-if="status_open">mdi-chevron-up</v-icon>
                <v-icon class="select-icon" v-else>mdi-chevron-down</v-icon>
              </div>
            </div>
            <div :class="[$vuetify.display.mobile ? 'w-100' : 'w-25','search-bar-element d-flex flex-column align-start']">
              <div class="search-bar-label mb-2 mt-md-0 mt-4">
                Rodzaj
              </div>
              <div class="search-bar-select-wrapper">
                <select class="search-bar-select" v-model="search_data.selected_transport_type">
                  <option value="" selected>Wszystkie rodzaje</option>
                  <option value="INTERNAL">Wewnętrzny</option>
                  <option value="PATIENT">Pacjencki</option>
                </select>
                <v-icon class="select-icon" v-if="status_open">mdi-chevron-up</v-icon>
                <v-icon class="select-icon" v-else>mdi-chevron-down</v-icon>
              </div>
            </div>
            <v-spacer></v-spacer>
          </div>

          <v-divider class="my-md-3 my-6 mx-md-6"></v-divider>

          <div class="search-bar text-left pa-md-6 pa-0 d-flex flex-row justify-space-between">
            <v-spacer></v-spacer>
            <div class="search-bar-element mr-10 d-flex flex-column justify-center">
              <v-btn id="reset" flat variant="plain" color="primary"
              :class="['']" 
              :size="$vuetify.display.mobile ? 'x-small' : 'x-default'" @click="resetAll">
                Wyczyść filtry
              </v-btn>
            </div>
            <div class="search-bar-element d-flex flex-column align-self-end">
              <v-btn
                  flat
                  rounded
                  color="primary"
                  height="40"
                  class="text-uppercase"
                  @click="setNewFilters"
                  :prepend-icon="'mdi-magnify'"
              >
                  Szukaj
              </v-btn>
            </div>

          </div>
        </div>

        <div
          class="text-left px-6 mb-2 mt-12 d-flex flex-md-row flex-column justify-space-between"
          v-if="reservations.length"
        >
          <div class="search-bar-element mr-4 d-flex flex-column align-start w-100">
            <div class="search-results-count mt-0">
              Wyświetlanie wyników {{ countFrom }} - {{ countTo }} z {{ totalCount }}
            </div>
          </div>
        </div>

        <div class="info-wrapper">
          <div v-if="!isLoading && !reservations.length" :class="['info d-flex flex-column justify-center mt-4 mb-2 mx-4 py-12 px-9', $vuetify.display.mobile ? 'mobile' : 'text-left']">
            <div class="header mb-6 mb-md-4">
              {{this.hasFilters ? "Nie znaleziono rezerwacji" : "Nie ma jeszcze żadnych rezerwacji"}}
            </div>
            <div class="subheader">
              {{this.hasFilters ? "Zmień kryteria wyszukiwania" : "Po dodaniu ich, będą one widoczne w tym miejscu"}}
            </div>
          </div>
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
            :size="50"
            :width="5"
          ></v-progress-circular>
        </div>

        <div v-if="reservations.length" :key="refresh_key">
          <div v-for="(reservation, index) in reservations" :key="index" class="mt-4">
            <coordinator-reservation-component :reservation="reservation" @compare-dialog="hasOpenCompareDialog"/>
          </div>
          <v-row class="my-9" v-if="paginationLength">
            <v-col cols="12" md="9">
              <v-pagination
                v-model="page"
                color="primary"
                :length="paginationLength"
              ></v-pagination>
            </v-col>
            <v-col cols="6" md="2" class="px-0 text-right">
                <div class="results-page-size-label mt-3 pr-2">{{$t('results.per_page_label')}}:</div>
            </v-col>
            <v-col cols="4" md="1" class="pl-0 pr-3">
                <div class="float-left mt-1 mb-16 w-100">
                    <CustomSelect
                        v-model="selectedPageSize"
                        :multiple="false"
                        :flat="true"
                        size="small"
                        :chip="false"
                        :options="[{key: 5}, {key: 10}, {key: 20}, {key: 50}]"/>
                </div>
            </v-col>
          </v-row>
        </div>
    </div>
</template>

<script>
import CoordinatorReservationComponent from "./ReservationComponent.vue";
import CustomSelect from "../CustomSelectComponent";
import { RemoteFilters, RemoteSorters } from "design-system-ui-components";
import { computed } from "vue";
import axios from "axios";

export default {
    name: "booking-component",
    data: () => {
        return {
            reservations: [],
            selectedPageSize: [],
            page: 1,
            pageSize: 10,
            paginationLength: 0,
            totalCount: 0,
            isLoading: false,
            prices: null,
            refresher: null,
            refresh_key: 0,
            openedCompareDialog: false,
            showFilters: true,
            search_data: {
              id: "",
              query: "",
              is_mz: "",
              selected_location: "",
              selected_status: "",
              selected_date: "",
              selected_transport_status: "",
              selected_transport_type: ""
            },
            search_data_local: {
              id: "",
              query: "",
              is_mz: "",
              selected_location: "",
              selected_status: "",
              selected_date: "",
              selected_transport_status: "",
              selected_transport_type: ""
            },
            location_open: false,
            status_open: false,
            hasFilters: false,
            locations: [],
            statuses: [
              {
                code: "CANCELED",
                id: 1
              },
              {
                code: "CANCELED_BY_USER",
                id: 6
              },
              {
                code: "CREATED",
                id: 3
              },
              {
                code: "ERROR",
                id: 4
              },
              {
                code: "FINISHED",
                id: 5
              },
              {
                code: "PROCESSED",
                id: 2
              },
              {
                code: "PAYMENT_IN_PROGRESS",
                id: 7
              },
            ],
          transport_statuses: [
              {
                code: "CREATED",
                id: 1
              },
              {
                code: "PAID",
                id: 2
              },
              {
                code: "PLANNED",
                id: 3
              },
              {
                code: "SEND",
                id: 4
              },
              {
                code: "FINISHED",
                id: 5
              },
              {
                code: "CANCELED",
                id: 6
              }
            ]
        }
    },
    components: {
      CoordinatorReservationComponent,
      CustomSelect
    },
    setup() {
      const box_icon = computed({
        get: () => { return require('@/assets/icons/box.svg'); }
      })
      const truck_icon = computed({
        get: () => { return require('@/assets/icons/truck.svg'); }
      })
      return {
        box_icon,
        truck_icon
      }
    },
    computed: {
      countFrom() {
          return 1 + this.pageSize * (this.page - 1)
      },
      countTo() {
        if(this.totalCount < this.pageSize * (this.page)) {
          return this.totalCount
        } else {
          return this.pageSize * this.page
        }
      }
    },
    created() {
      this.selectedPageSize = [{key: this.pageSize}]
    },
    mounted() {
      this.getDicts().then(() => {
        this.refresher = setInterval(() => {
          if (!this.openedCompareDialog) {
            this.init(this.page);
            this.refresh_key++;
          }
        }, 60 * 1000);  
      })
    },
    unmounted() {
      clearInterval(this.refresher);
    },
    watch: {
      page(p) {
        this.init(p);
        window.scrollTo({top: 0, behavior: 'smooth'});
      },
      selectedPageSize(p) {
        this.pageSize = p[0].key
        if (this.page != 1) {
          this.page = 1
        } else {
          this.init(1)
        }
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
    },
    methods: {
      hasOpenCompareDialog(d) {
        this.openedCompareDialog = d
      },
      init(page = 1) {
        this.isLoading = true
        this.page = page
        axios.get(this.getUrl(page))
        .then((response) => {
          this.reservations = response.data.reservations;
          this.paginationLength = Math.ceil(response.data.total_count / this.pageSize);
          this.totalCount = response.data.total_count;
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        })
      },
      resetAll() {
        this.search_data = {
              id: "",
              query: "",
              is_mz: "",
              selected_location: "",
              selected_status: "",
              selected_date: "",
              selected_transport_status: "",
              selected_transport_type: ""
            },
        this.hasFilters = false;
        this.setNewFilters();
      },
      getDicts() {
        return new Promise((resolve, reject) => {
          axios.get('/api/personal_data/dictionary')
            .then((response) => {
              this.locations = response.data.location;
              resolve(response);
            })
            .catch(error => {
              console.error(error);
              reject(error)
            })
          })
      },
      getUrl(page) {
        this.hasFilters = false;
        const api = "/api/coordinator/reservations?reservation_type=initial";
        const filters = new RemoteFilters();
        const sorters = new RemoteSorters();

        sorters.add({
          property: "id", 
          direction: "DESC"
        })

        if(this.search_data_local.id) {
          const value = parseInt(this.search_data_local.id);
          filters.add({
            property: "id;reservation_data.donor_id",
            operator: isNaN(parseInt(value)) ? "_like" : "=",
            value: isNaN(parseInt(value)) ? this.search_data_local.id : value,
          })
          this.hasFilters = true;
        }
        if(this.search_data_local.query) {
          filters.add({
            property: "query",
            operator: "_like",
            value: this.search_data_local.query.replace(/\s/g,''),
          })
          this.hasFilters = true;
        }
        if(this.search_data_local.is_mz) {
          filters.add({
            property: "is_mz",
            operator: "=",
            value: this.search_data_local.is_mz,
          })
          this.hasFilters = true;
        }
        if(this.search_data_local.selected_location) {
          filters.add({
            property: "reservation_data.location_of_treatment_name",
            operator: "=",
            value: this.search_data_local.selected_location
          })
          this.hasFilters = true;
        }
        if(this.search_data_local.selected_status) {
          filters.add({
            property: "status",
            operator: "=",
            value: this.search_data_local.selected_status
          })
          this.hasFilters = true;
        }
        if(this.search_data_local.selected_date) {
          filters.add({
            property: "reservation_time",
            operator: "=",
            value: this.search_data_local.selected_date
          })
          this.hasFilters = true;
        }
        if(this.search_data_local.selected_transport_status) {
          filters.add({
            property: "transport_data.status_code",
            operator: "=",
            value: this.search_data_local.selected_transport_status
          })
          this.hasFilters = true;
        }
        if(this.search_data_local.selected_transport_type) {
          filters.add({
            property: "transport_data.type",
            operator: "=",
            value: this.search_data_local.selected_transport_type
          })
          this.hasFilters = true;
        }
        
        const pagination = `&pageNumber=${page-1}&pageSize=${this.pageSize}`;

        const url = `${api}${this.hasFilters ? '&' + filters.stringify() : ''}${pagination}&${sorters.stringify()}`;

        return url;
      },
      setNewFilters() {
        this.search_data_local = {...this.search_data};
        this.init(1)
      },
      goToOrderTransport() {
        this.$router.push({name: 'coordinatorTransportOrder'});
      }
    }
}
</script>

<style lang="scss" scoped>
.booking-component {
  box-sizing: border-box;
  background: none;
}
.main-header {
  @include nsb-poppins-semibold;
}
.results-page-size-label {
  @include nsb-font-container;
  font-size: 14px;
}
.v-row {
  margin: 0px !important;
  padding: 0px !important;
}

:deep(.v-pagination__item) {
  margin-right: 0px;
  .v-btn {
    @include nsb-font-button-regular;
    font-size: 14px !important;
    line-height: 21px !important;
    max-height: 40px;
    max-width: 40px;
  }
  &.v-pagination__item--is-active {
    .v-btn {
      background-color: $ds-primary !important;
      color: $ds-white !important;
      .v-btn__overlay {
        opacity: 0;
      }
    }
  }
}
:deep(.v-pagination__prev) {
  margin-right: 8px;
  .v-btn {
    font-size: 14px !important;
    max-height: 40px;
    max-width: 40px;
  }
}
:deep(.v-pagination__next) {
  margin-left: 12px;
  .v-btn {
    font-size: 14px !important;
    max-height: 40px;
    max-width: 40px;
  }
}

.info-wrapper {
  position: relative;
  .v-progress-circular {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 999;
    transform: translate(-50%,-50%);
  }
  .info{
    height: 350px;
    .header {
      @include nsb-font-header-bold;
      font-size: 20px !important;
      line-height: 30px !important;
    }
    .subheader {
      @include nsb-font-header;
      font-size: 14px !important;
      line-height: 22px !important;
    }
    &.mobile {
      .header {
        font-size: 14px !important;
        line-height: 22px !important;
      }
      .subheader {
        font-size: 12px !important;
        line-height: 18px !important;
      }
    }
  }
}

.filter-wrapper {
  background: white;
  .filter-header {
    font-size: 16px;
    line-height: 26px;
  }
}
.v-divider {
  border-color: var(--borders-dividers-default, #E2E6EE) !important;
}
.search-bar {
  background: white;
  max-width: 100%;
}
.search-bar-element {
	.search-bar-label {
		@include nsb-font-container;
    font-size: 14px !important;
	}
  .search-results-count {
    @include nsb-font-container;
		line-height: 18px;
    text-transform: uppercase;
    color: var(--Text-accent-dark, #4B618B);
  }
  .query {
    max-width: 180px !important;
  }
	.search-bar-input, .search-bar-select {
		@include nsb-font-input;
		font-size: 16px !important;
    border-radius: 4px;
    border: 1px solid $ds-background-1 ;
		height: 40px;
		padding: 0px 16px;
    padding-right: 32px;
		outline: none;
    text-overflow: ellipsis;
    width: 100%;
    option {
      text-overflow: ellipsis;
      padding-right: 32px;
    }
    &[type="date"] {
      padding-right: 8px;
    }
	}
  .search-bar-select-wrapper {
    position: relative;
    width: 100% !important;
    .select-icon {
      position: absolute;
      color: $ds-primary;
      top: 8px;
      right: 8px;
      pointer-events: none;
    }
  }
}
/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  user-select: none;
  @include nsb-font-container;
  font-size: 14px;
  line-height: 21px;
  max-width: 204px;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  box-sizing: border-box;
  border: 1px solid #00205B;
  -webkit-transform: translate(0,-50%);
  transform: translate(0,-50%);
  position: absolute;
  top: 50%;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: white;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: $nsb-disabled;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: $ds-primary;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 5px;
  top: 2px;
  width: 4px;
  height: 9px;
  border: solid white;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>